// extracted by mini-css-extract-plugin
module.exports = {"margin":"InspectorCarInfoSection_margin__y8coO"};